export default function WolfCrest({ className = "w-10 h-10" }) {
  return (
    <svg viewBox="0 0 48 48" className={className} role="img" aria-label="Campaign cross logo" data-testid="blue-cross-logo">
      <rect x="19.5" y="3" width="9" height="43" rx="2" fill="#1F4E79" />
      <rect x="6" y="13" width="36" height="9" rx="2" fill="#1F4E79" />
    </svg>
  );
}
